import { Injectable } from "@angular/core";
import { PessoaFisicaJuridicaController } from "app/controllers/grl/pessoa-fisica-juridica.controller";
import { PessoaFisicaJuridicaDTO } from "app/model/dtos/grl/pessoa-fisica-juridica.dto";
import { LoaderService } from "../loader.service";

@Injectable()
export class PessoaFisicaJuridicaService{

    constructor(
        private _pessoaFisicaJuridicaController: PessoaFisicaJuridicaController,
        private _loaderService: LoaderService
    ){}

    getPessoaByCPFCNPJ(nrCpfCnpj: string): Promise<PessoaFisicaJuridicaDTO> {
        this._loaderService.show();
        return this._pessoaFisicaJuridicaController.getPessoaByCPFCNPJ(nrCpfCnpj).finally(() => this._loaderService.hide());
    }
}